module.exports = __webpack_public_path__ + "img/实验室净化3.56796d94.jpg";